<template>
  <CommonExpansionPanel :currentPanel="0" >
    <template v-slot:title-panel>
      Estadísticas
    </template>
    <v-expansion-panel-content>
      <div style="padding: 30px;">
        <v-row>
          <v-col cols="12" md="7">
            <div class="d-md-flex">
              <span
                class="text-subtitle-1 font-weight-bold mt-1 mr-2"
                style="color: #4D5358"
                >Filtrar por periodo</span
              >
              <InputPeriodo
                @updateDate="getTodosLosClientes"
                style="min-width: 50%;"
              ></InputPeriodo>
            </div>
          </v-col>
        </v-row>
        <div v-if="!loading">
          <v-row v-if="!noResults">
            <v-col cols="12" md="6" xs="12" style="align-self: center;">
              <cards-info-polizas :clientes="todosLosClientes" />
            </v-col>
            <v-col cols="12" md="6">
              <clientes-status-graphic
                :clientes="todosLosClientes"
              ></clientes-status-graphic>
            </v-col>
          </v-row>
          <div v-else>
            <v-col
              cols="12"
              md="12"
              style="align-items: center; text-align: center; padding: 5%;"
            >
              <span class="titulo-header">Sin resultados que mostrar</span>
            </v-col>
          </div>
        </div>
        <div v-else>
          <v-row>
            <v-col>
              <v-col cols="12" class="d-flex align-md-center justify-md-center">
                <v-img
                  class="responsive"
                  contain
                  max-height="200"
                  max-width="300"
                  :src="loader.createAccount"
                ></v-img>
              </v-col>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-expansion-panel-content>
  </CommonExpansionPanel>
</template>

<script>
import CommonExpansionPanel from "@/components/commonComponents/CommonExpansionPanel.vue";
import ClientesStatusGraphic from "@/components/commonComponents/charts/ClientesStatus.graphic.vue";
import CardsInfoPolizas from "./CardsInfoPolizas.vue";
import { mainAxios } from "@/mainAxios.js";
import InputPeriodo from "../../../../../components/commonComponents/forms/InputPeriodo.vue";
import loginData from "@/helpers/data/data-login-template.json";

export default {
  components: {
    ClientesStatusGraphic,
    CommonExpansionPanel,
    CardsInfoPolizas,
    InputPeriodo,
  },

  data() {
    return {
      switch_data: 1,
      todosLosClientes: {},
      requestConfig: {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      },
      todasLasEmisiones: {},
      loading: false,
      statusArray: ["Activo", "Baja", "Inactivo", "Nuevo"],
      noResults: false,
      loader: loginData,
    };
  },
  props: {
    contactData: Object,
    correosDataFormat: Object,
    routesContactData: Object,
  },
  methods: {
    changeComponent(component) {
      this.switch_data = component;
      this.$emit("getData");
    },
    getTodosLosClientes(dates) {
      this.loading = true;
      let body={
        fechas: dates
      }
      if(String(window.location.pathname).includes('/alianza/perfil/')){
        body.alianza = parseInt(this.$route.params.alianza_id);
      }

      mainAxios
        .post(`v1/cliente/dashboard/data`, body, this.requestConfig)
        .then(({ data }) => {
          this.todosLosClientes = data;
          this.loading = false;
          this.checkIfHasResults();
        });
    },
    checkIfHasResults() {
      var count = 0;
      this.noResults = false;
      this.statusArray.map((e) => {
        if (this.todosLosClientes.status[e] == 0) count++;
      });
      if (count == Object.keys(this.todosLosClientes.status).length)
        this.noResults = true;
    },
  },
};
</script>
